import { Stack } from "@fluentui/react";
import { Fragment } from "react/jsx-runtime";

import { IInvoiceInfos } from "@/components/Contracts/components/Invoice/interfaces";
import type {
  Contract,
  ContractApprovalFlowResponse
} from "@/components/Contracts/contract.interface";
import { DisplayContractInfo } from "@/components/Contracts/DisplayContractInfo";
import { Loader } from "@/components/Shared/Loader";
import { useGet } from "@/core/libs/api/react-query/hook/use-get";

export function ViewContract({
  contractId
}: {
  contractId: number;
}): JSX.Element {
  const { data: contract, isFetching } = useGet<Contract>({
    url: `contracts/${contractId}`,
    queryToken: `contract-${contractId}`
  });

  const { data: invoiceInfos } = useGet<IInvoiceInfos>({
    url: `contracts/${contractId}/payment-conditions`,
    queryToken: `payment-conditions-${contractId}`
  });

  return (
    <Fragment>
      {isFetching ? (
        <Loader />
      ) : (
        <Stack tokens={{ childrenGap: 15 }}>
          <DisplayContractInfo
            clientInfoTitle={"Cooperado"}
            contractInfoTitle={"Informações"}
            className="ms-Grid-col ms-sm12 ms-lg6"
            contract={contract}
            defaultProductCompactMode
            isInsidePanel
            invoiceInfos={invoiceInfos}
          />
        </Stack>
      )}
    </Fragment>
  );
}
